module.exports = __webpack_public_path__ + "img/code-fork.19c348f0.svg";